import { ReactElement } from "react"
import { useForm, FormField } from "@stackup/form"

interface FieldProps<V> {
  value: V
  error?: string
  touched?: boolean
  children: (field: FormField<V>) => ReactElement
}

export function Field<V>(props: FieldProps<V>) {
  const form = useForm({
    initialValue: props.value,
    initialError: props.error,
    initialTouched: props.touched,
  })

  return props.children(form)
}
